import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { hasInventory } from '../inventory/fleetPanelData';

// Per-project ⋯ menu. Delete moved here from the card face (STRY0038867).
const ProjectActionsMenu = ({ project, canModify, actions }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onPointer = e => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = e => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const run = handler => e => {
    e.stopPropagation();
    setOpen(false);
    handler(project);
  };

  return (
    <span className="pl-menu" ref={ref} onClick={e => e.stopPropagation()} onDoubleClick={e => e.stopPropagation()}>
      <button
        type="button"
        className="pl-iconbtn"
        aria-label={`Actions for ${project.name}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(current => !current)}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <circle cx="5" cy="12" r="1.6" />
          <circle cx="12" cy="12" r="1.6" />
          <circle cx="19" cy="12" r="1.6" />
        </svg>
      </button>
      {open && (
        <div className="pl-pop" role="menu">
          <button type="button" role="menuitem" onClick={run(actions.open)}>
            Open project
          </button>
          {canModify && (
            <button type="button" role="menuitem" onClick={run(actions.startRename)}>
              Rename
            </button>
          )}
          <button type="button" role="menuitem" onClick={run(actions.exportReport)}>
            Export report
          </button>
          {canModify && hasInventory(project) && (
            <button type="button" role="menuitem" onClick={run(actions.refresh)}>
              Refresh inventory
            </button>
          )}
          {canModify && (
            <>
              <hr />
              <button type="button" role="menuitem" className="is-danger" onClick={run(actions.remove)}>
                Delete…
              </button>
            </>
          )}
        </div>
      )}
    </span>
  );
};

ProjectActionsMenu.propTypes = {
  project: PropTypes.object.isRequired,
  canModify: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    open: PropTypes.func.isRequired,
    startRename: PropTypes.func.isRequired,
    exportReport: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired
  }).isRequired
};

export default ProjectActionsMenu;
